import { userService } from "./user";
import { coinTransactionService } from "./coin-transaction";
import { charlistservice, charquipmentService, serverService, profileequipmentService, guildService } from "./services";
import { auditlogservice } from "./audit";
import { faqService } from "./faq";
let reg = process.env.VUE_APP_REGION_URL;


class ApiService {
    user
    coinTransaction
    charlist
    charequipment
    servers
    profileequipment
    auditLogs
    guildService
    faqs
    constructor(url) {
        this.user = new userService(url);
        this.coinTransaction = new coinTransactionService(url);
        this.charlist = new charlistservice(url);
        this.charequipment = new charquipmentService(url);
        this.servers = new serverService(url)
        this.profileequipment = new profileequipmentService(url)
        this.auditLogs = new auditlogservice(url)
        this.guild = new guildService(url)
        this.faqs = new faqService(reg + "/")
    }
}


export const apiService = ApiService